module.exports = __webpack_public_path__ + "img/Productivity.8b86a2b9.svg";